/**
 * **中文词典（基准）。**
 *
 * `TextKey` 由这里推出，所以**加文本先加这里**；`en.ts` 按同一批键补英文
 * （`test/i18n.test.ts` 会断言两边键集一致且没有空译文）。
 *
 * 命名空间按代码区域切分（menu / room / game / core …）。同一个命名空间
 * 里的键用 `区域.用途`，例如 `title.netplay`。
 */

import common from './zh/common';
import menu from './zh/menu';
import room from './zh/room';
import settings from './zh/settings';
import credit from './zh/credit';
import game from './zh/game';
import render from './zh/render';
import core from './zh/core';
import host from './zh/host';
import audio from './zh/audio';
import packs from './zh/packs';
import debug from './zh/debug';
import dev from './zh/dev';

export const zh = {
  ...common,
  ...menu,
  ...room,
  ...settings,
  ...credit,
  ...game,
  ...render,
  ...core,
  ...host,
  ...audio,
  ...packs,
  ...debug,
  ...dev,
} as const;

export type TextKey = keyof typeof zh;

